import { TextAndImageSelectionField } from 'components';
import Survey from '@app/illu/Large/Survey.svg';
import Recording from '@app/illu/Large/Recording.svg';
import { SessionFormat } from 'queries';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase * 2 + 'px',

    [theme.media.desktop]: {
      flexDirection: 'row',
      flexWrap: 'no-wrap',
    },
  },
}));

export const StudyFormatUnmoderatedSection = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <TextAndImageSelectionField
        illustration={Survey}
        title={t('studySetup.generalSetup.format.survey')}
        description={t('studySetup.generalSetup.format.surveyDesc')}
        name="format"
        value={SessionFormat.SURVEY}
        trackingName="Format"
      />
      <TextAndImageSelectionField
        illustration={Recording}
        title={t('studySetup.generalSetup.format.recording')}
        description={t('studySetup.generalSetup.format.recordingDesc')}
        name="format"
        value={SessionFormat.RECORDING}
        trackingName="Format"
      />
    </div>
  );
};
